import { get } from 'lodash';
import MfaStrings from 'client/containers/Login/MfaStrings';

const getTextByMFATypeForContext = mfaType => (context) => {
  const defaultText = get(MfaStrings.contexts, `${mfaType}.login`);

  return get(MfaStrings.contexts, `${mfaType}.${context}`, defaultText);
};

export default getTextByMFATypeForContext;
